var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Utilities',[(_vm.showSocials)?_c('SocialSharing'):_vm._e(),_c('Support',{on:{"toggle-overlay":_vm.handleToggleOverlay}}),_c('Reset'),_c('Undo'),_c('Open')],1)}
var staticRenderFns = []

export { render, staticRenderFns }